module.exports = __webpack_public_path__ + "static/media/bj.aa6d71d3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bj.svg
// module id = 779
// module chunks = 0